// Theme tokens for the Default template
// Used by both PDF and DOCX renderers. Units are in pt

const theme = {
  colors: {
    primary: '#016fb9',
    foreground: '#000000',
    border: '#cecece',
    background: '#ffffff',
    surface: '#f5f5f5',
  },

  typography: {
    fontFamily: 'Poppins',
    lineHeight: 1.35,
    /** All values in pt */
    fontSize: {
      xs: 9,
      sm: 9.5,
      base: 10,
      lg: 11,
      xl: 11.5,
      '2xl': 12,
      '3xl': 13,
      '4xl': 14,
      '5xl': 15,
      '6xl': 24,
    },
  },

  spacing: {
    /** Layout dimensions (pt) */
    headerHeight: 52,
    footerHeight: 35,
    pagePadding: 19,
    sidebarWidth: 228,
    containerGap: 14,
    cardPaddingX: 15,
    cardPaddingY: 8,
    cardRadius: 8,

    /** Semantic spacing (pt) */
    bulletBefore: 1.5,
    small: 2,
    socialGap: 3,
    medium: 4,
    large: 5,
    sectionBottom: 6,
    schoolAfter: 7,
    sectionHeadingMargin: 15,

    /** Element sizes (pt) */
    iconSize: 14,
    avatarSize: 140,
    logoWidth: 76,
    logoHeight: 20,
  },
} as const;

export default theme;

/** Section heading labels */
export const SECTION_TITLES = {
  bio: 'ABOUT ME',
  experience: 'JOB EXPERIENCE',
  education: 'EDUCATION',
  skills: 'TECHNICAL SKILLS',
  certifications: 'CERTIFICATIONS',
} as const;
